export const UPDATE_TYPE = {
  ADD: 0,
  DELETE: 1,
  UPDATE: 2
};



// WEBPACK FOOTER //
// ./ecology9/wea-tree-test/react-virtualized-tree/src/contants.js